import ResourcesSearch from './ResourcesSearch'

export default ResourcesSearch
